<script>
import appConfig from '@src/app.config.json'
import Axios from 'axios'
import Layout from '@layouts/main.vue'
import Hero from '@components/ui/hero-jumbotron.vue'
import PlainCard from '@components/ui/cards/plain-card.vue'

export default {
  page: {
    title: 'About Us',
    meta: [{ name: 'description', content: 'The About Us page.' }],
  },
  components: {
    Layout,
    Hero,
    PlainCard,
  },
  data() {
    return {
      isActive: null,
      About: {},
      scrollpx: 0,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      lastScrolled: 0,
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  async mounted() {
    await this.getAbout()
  },
  methods: {
    scrollToView: function(to) {
      this.isActive = to
      this.$refs[to][0].scrollIntoView()
    },
    getAbout: function() {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'about-us',
        simple: true,
        lang: this.lang,
        taxonomy_show: false,
        attribute_show: false,
      }
      /** params need to encoded from object to url params */
      params = Object.keys(params)
        .map(function(key) {
          return key + '=' + params[key]
        })
        .join('&')
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-by-member-relation?${params}`
      // get the news
      Axios.get(endpoint, getOptions).then((response) => {
        const data = response.data.data
        console.log(data)
        if (response.data) {
          this.About = data
        }
      })
    },
    handleScroll: function() {
      this.scrollpx = window.scrollY
      if (this.scrollpx > 600 && this.scrollpx < this.lastScrolled) {
        document.getElementById('navigation').classList.add('d-none')
      } else if (this.scrollpx < 75) {
        document.getElementById('navigation').classList.remove('d-none')
      }
      this.lastScrolled = this.scrollpx
    },
  },
}
</script>

<template>
  <Layout>
    <Hero
      height="25rem"
      :background="require('@assets/images/demo/about/Banner_0.jpg')"
    >
    </Hero>

    <b-container class="my-5">
      <b-row>
        <b-col cols="lg-8">
          <div v-scroll-spy :class="$style.aboutUsContent">
            <section
              v-for="(item, index) in About"
              :key="index"
              :ref="item.slug"
            >
              <h1 class="text-dark mb-3" bold>{{ item.title }}</h1>
              <div v-html-safe="item.content"></div>
              <hr v-if="About[About.length - 1].slug !== item.slug" />
            </section>
          </div>
        </b-col>
        <b-col cols="lg-4" class="pl-3 pl-lg-5">
          <div :class="$style.sidebarNav">
            <PlainCard :header-borderless="true" title="Sections">
              <ul v-scroll-spy-active v-scroll-spy-link="{ selector: 'li' }">
                <li
                  v-for="(item, index) in About"
                  :key="index"
                  :class="[isActive === item.slug ? 'active' : '']"
                  pointer
                  @click="scrollToView(item.slug)"
                  >{{ item.title }}</li
                >
              </ul>
            </PlainCard>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
</template>

<style lang="scss" module>
.team {
  margin-top: 3rem;
  .eachTeamMate {
    display: flex;
    align-items: center;
    img {
      width: 7rem;
      height: 7rem;
      border-radius: 50%;
    }
    .teamMateContent {
      margin-left: 1.75rem;
    }
  }
}
.sidebarNav {
  position: sticky;
  top: 2rem;
}
.aboutUsContent {
  h2 {
    color: #6c757d;
  }
}
</style>
